export default __webpack_public_path__ + "static/media/tag_clap_en.f1bf8113.gif";